"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainFields = void 0;
const react_1 = __importDefault(require("react"));
function DomainFields(options) {
    return react_1.default.createElement(react_1.default.Fragment, null, options.FieldsComponent && react_1.default.createElement(options.FieldsComponent, null));
}
exports.DomainFields = DomainFields;
//# sourceMappingURL=domain-fields.js.map